"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transpileStatement = void 0;
const expressions_1 = require("./expressions");
const names_1 = require("./names");
function transpileStatement(statement) {
    const { name, expression } = statement;
    const bodyCode = expressions_1.transpileExpression(expression);
    return `const ${names_1.validJsName(name)} = ${bodyCode};`;
}
exports.transpileStatement = transpileStatement;
//# sourceMappingURL=statements.js.map